import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { AfterContentChecked, Component, Input } from '@angular/core';

@Component({
  selector: 'app-tabs-stepper',
  templateUrl: './tabs-stepper.component.html',
  styleUrls: ['./tabs-stepper.component.scss'],
  providers: [{ provide: CdkStepper, useExisting: TabsStepperComponent }],
})
export class TabsStepperComponent
  extends CdkStepper
  implements AfterContentChecked
{
  results: CdkStep[] = [];

  @Input('tabsEnabled') tabsEnabled: boolean = true;
  //Clase para el header del stepper (pasos con número)
  @Input('headerClass') headerClass: string = '';
  // Class para el body del stepper (cdk-step | ng-content)
  @Input('bodyClass') bodyClass: string = '';

  ngAfterContentChecked(): void {
    this.results = this.steps.toArray();
  }

  navigateToIndex(index: number) {
    this.selectedIndex = index;
  }
}
